// Curadoria de links internos entre artigos e ferramentas.
// Objetivo SEO: garantir que cada página importante seja alcançável em ≤2 cliques
// e reforçar tópicos relacionados (topical authority).

import { tools } from "@/lib/tools";

export type ArticleMeta = {
  slug: string;
  titulo: string;
  resumo: string;
  categoria: string;
};

// Lista enxuta dos artigos publicados — usada por widgets de "relacionados".
// Mantenha sincronizada com ARTIGOS em src/routes/artigos.$slug.tsx.
export const articlesMeta: ArticleMeta[] = [
  {
    slug: "o-que-e-mei",
    titulo: "O que é MEI? Guia completo",
    resumo: "Conceitos, benefícios e obrigações do Microempreendedor Individual.",
    categoria: "fundamentos",
  },
  {
    slug: "como-formalizar-mei",
    titulo: "Como formalizar seu MEI",
    resumo: "Passo a passo para abrir o CNPJ no Portal do Empreendedor.",
    categoria: "formalizacao",
  },
  {
    slug: "portal-mei-guia-completo",
    titulo: "Portal MEI: guia de acesso e uso",
    resumo: "Portal do Empreendedor, PGMEI, Gov.br e app MEI explicados.",
    categoria: "formalizacao",
  },
  {
    slug: "atividades-permitidas-mei",
    titulo: "Atividades permitidas para MEI",
    resumo: "Lista de CNAEs e como verificar a sua atividade.",
    categoria: "formalizacao",
  },
  {
    slug: "alvara-funcionamento-mei",
    titulo: "Alvará de funcionamento do MEI",
    resumo: "Como funciona o alvará e o que muda por município.",
    categoria: "formalizacao",
  },
  {
    slug: "certificado-digital-mei",
    titulo: "Certificado digital para MEI",
    resumo: "Quando o MEI precisa de certificado e como obter.",
    categoria: "formalizacao",
  },
  {
    slug: "alterar-dados-mei",
    titulo: "Como alterar dados do MEI",
    resumo: "Mude endereço, atividade ou nome fantasia no CNPJ.",
    categoria: "formalizacao",
  },

  {
    slug: "das-boleto-mei",
    titulo: "DAS do MEI: gerar, pagar e parcelar",
    resumo: "PGMEI, app MEI, Pix, débito automático e atrasos.",
    categoria: "tributos",
  },
  {
    slug: "como-calcular-das-mei-2026",
    titulo: "Como Calcular o DAS MEI 2026: guia completo",
    resumo: "Tabela, fórmula, exemplos práticos e passo a passo no PGMEI.",
    categoria: "tributos",
  },
  {
    slug: "limite-faturamento-mei",
    titulo: "Limite de Faturamento MEI 2026: Quanto Você Pode Ganhar",
    resumo: "Descubra o teto de faturamento do MEI em 2026, cálculo proporcional, PLC 108/2021 e o que fazer se ultrapassar.",
    categoria: "tributos",
  },
  {
    slug: "mei-imposto-de-renda",
    titulo: "MEI e Imposto de Renda",
    resumo: "Quando o MEI declara IRPF e como calcular.",
    categoria: "tributos",
  },
  {
    slug: "mei-simples-nacional",
    titulo: "MEI no Simples Nacional",
    resumo: "Como o MEI se encaixa no Simples e o que muda.",
    categoria: "tributos",
  },
  {
    slug: "reforma-tributaria-mei",
    titulo: "Reforma tributária e MEI",
    resumo: "O que muda para o microempreendedor com a reforma.",
    categoria: "tributos",
  },
  {
    slug: "nota-fiscal-mei",
    titulo: "Nota fiscal para MEI",
    resumo: "Quando emitir, como emitir e tipos de NF para MEI.",
    categoria: "tributos",
  },
  {
    slug: "microempreendedor-individual-nota-fiscal-eletronica",
    titulo: "MEI e Nota Fiscal Eletrônica: guia 2026",
    resumo: "NFS-e nacional, CRT 4 e obrigatoriedade da NF para o MEI.",
    categoria: "tributos",
  },
  {
    slug: "inss-mei-2026",
    titulo: "INSS MEI 2026: valores e benefícios",
    resumo: "Quanto paga, benefícios e como complementar a contribuição.",
    categoria: "previdencia",
  },
  {
    slug: "obrigacoes-mensais-mei",
    titulo: "Obrigações mensais do MEI",
    resumo: "Checklist completo do que o MEI precisa fazer todo mês.",
    categoria: "tributos",
  },

  {
    slug: "parcelamento-dividas-mei",
    titulo: "Parcelamento de dívidas do MEI",
    resumo: "Como regularizar DAS atrasado e voltar à ativa.",
    categoria: "regularizacao",
  },
  {
    slug: "mei-inadimplente",
    titulo: "MEI inadimplente: o que fazer",
    resumo: "Consequências e caminhos para regularizar débitos.",
    categoria: "regularizacao",
  },
  {
    slug: "mei-nome-sujo",
    titulo: "MEI com nome sujo",
    resumo: "Como o CNPJ pode ir para o SPC/Serasa e como sair.",
    categoria: "regularizacao",
  },
  {
    slug: "como-cancelar-mei-dar-baixa",
    titulo: "Como cancelar o MEI (dar baixa)",
    resumo: "Passo a passo para baixar o CNPJ corretamente.",
    categoria: "regularizacao",
  },

  {
    slug: "mei-pode-ter-funcionario",
    titulo: "MEI pode ter funcionário?",
    resumo: "Regras, custos e como contratar 1 empregado.",
    categoria: "trabalhista",
  },
  {
    slug: "mei-pode-ter-socio",
    titulo: "MEI pode ter sócio?",
    resumo: "Por que o MEI não pode ter sócio e alternativas.",
    categoria: "trabalhista",
  },
  {
    slug: "mei-clt-carteira-assinada",
    titulo: "Ser MEI tendo carteira assinada",
    resumo: "Como conciliar CLT e MEI sem perder direitos.",
    categoria: "trabalhista",
  },

  {
    slug: "mei-inss-aposentadoria",
    titulo: "MEI, INSS e aposentadoria",
    resumo: "Como funciona o INSS pago no DAS e o tempo de contribuição.",
    categoria: "previdencia",
  },
  {
    slug: "beneficios-previdenciarios-mei",
    titulo: "Benefícios previdenciários do MEI",
    resumo: "Auxílio-doença, salário-maternidade, aposentadoria.",
    categoria: "previdencia",
  },

  {
    slug: "mei-x-me-diferencas",
    titulo: "MEI x ME: diferenças e quando migrar",
    resumo: "Limites, impostos, sócios e funcionários comparados.",
    categoria: "crescimento",
  },
  {
    slug: "migrar-mei-para-me",
    titulo: "Como migrar do MEI para ME",
    resumo: "Passo a passo do desenquadramento sem dor de cabeça.",
    categoria: "crescimento",
  },
  {
    slug: "mei-e-commerce",
    titulo: "MEI no e-commerce",
    resumo: "Como vender online como MEI: marketplaces, NF, frete.",
    categoria: "crescimento",
  },
  {
    slug: "mei-feminino",
    titulo: "MEI feminino: dicas e benefícios",
    resumo: "Empreendedorismo feminino e o MEI no Brasil.",
    categoria: "crescimento",
  },
  {
    slug: "mei-prestar-servico-pj",
    titulo: "MEI prestando serviço para PJ",
    resumo: "Regras para contratar e prestar serviço entre empresas.",
    categoria: "crescimento",
  },
  {
    slug: "conta-pj-mei",
    titulo: "Conta PJ para MEI",
    resumo: "Comparativo de bancos digitais e tradicionais para MEI.",
    categoria: "crescimento",
  },
  {
    slug: "comparador-conta-pj",
    titulo: "Comparador de Conta PJ 2026",
    resumo: "Encontre a melhor conta digital para MEI e empresas.",
    categoria: "crescimento",
  },
  {
    slug: "simulador-emprestimo-mei",
    titulo: "Simulador de Empréstimo MEI 2026",
    resumo: "Calcule parcela e CET e compare Pronampe, fintechs e bancos.",
    categoria: "credito",
  },
  {
    slug: "simulador-maquininha",
    titulo: "Simulador de Maquininha 2026",
    resumo: "Compare taxas de Ton, PagBank, Mercado Pago, SumUp e InfinitePay.",
    categoria: "crescimento",
  },
  {
    slug: "mei-vs-clt-2026",
    titulo: "MEI ou CLT em 2026: qual vale mais a pena?",
    resumo: "Compare líquido nos dois regimes com IRPF da Reforma e DAS-MEI 2026.",
    categoria: "crescimento",
  },
  {
    slug: "ia-cnae-mei-2026",
    titulo: "CNAE MEI 2026: como a IA ajuda a escolher a atividade certa",
    resumo: "Descreva o que faz em linguagem natural e descubra o CNAE certo do seu MEI.",
    categoria: "formalizacao",
  },
  {
    slug: "entregador-mercado-livre-mei",
    titulo: "Como abrir MEI para ser entregador do Mercado Livre",
    resumo:
      "CNAE 5320-2/02, abertura no Portal do Empreendedor e custos do DAS para entregador MEI.",
    categoria: "formalizacao",
  },

  {
    slug: "como-obter-cartao-cnpj-rapido",
    titulo: "Como obter o Cartão CNPJ rápido",
    resumo: "Emissão online em minutos, gratuita, na Receita Federal.",
    categoria: "cartao-cnpj",
  },
  {
    slug: "vantagens-cartao-cnpj-para-empresas",
    titulo: "Vantagens do Cartão CNPJ",
    resumo: "Por que ter o Cartão CNPJ sempre à mão.",
    categoria: "cartao-cnpj",
  },
  {
    slug: "passo-a-passo-solicitar-cartao-cnpj",
    titulo: "Passo a passo para solicitar o Cartão CNPJ",
    resumo: "Tutorial completo de emissão na Receita.",
    categoria: "cartao-cnpj",
  },
  {
    slug: "cartao-cnpj-documentacao-necessaria-dicas",
    titulo: "Documentação para o Cartão CNPJ",
    resumo: "O que ter em mãos antes de emitir o Cartão CNPJ.",
    categoria: "cartao-cnpj",
  },
  {
    slug: "cartao-cnpj-importancia-legal",
    titulo: "Importância legal do Cartão CNPJ",
    resumo: "Por que o Cartão CNPJ é exigido em contratos e bancos.",
    categoria: "cartao-cnpj",
  },
  {
    slug: "desenquadramento-mei-como-agir",
    titulo: "Desenquadramento do MEI: causas e como agir",
    resumo: "Faturou acima do limite ou violou alguma regra? Veja os prazos e como regularizar.",
    categoria: "crescimento",
  },
  {
    slug: "ferramentas-mei-kit-gratuito",
    titulo: "Ferramentas para MEI 2026: o kit gratuito definitivo",
    resumo:
      "Monte um kit de recursos digitais gratuitos para a rotina do MEI em 2026: DAS, NFS-e e faturamento.",
    categoria: "gestao",
  },
  {
    slug: "irpf-mei-2026",
    titulo: "IRPF do MEI 2026: Como Declarar o Lucro no Imposto de Renda Sem Cair na Malha Fina",
    resumo: "Calcule a parcela isenta, preencha as fichas certas do IRPF e evite a malha fina.",
    categoria: "tributos",
  },
  {
    slug: "gestao-financeira-mei",
    titulo: "Gestão Financeira para MEI 2026: Fluxo de Caixa, Controle e Ferramentas Gratuitas",
    resumo: "Separe contas pessoais e empresariais, monte um fluxo de caixa e controle o limite de faturamento.",
    categoria: "gestao",
  },
  {
    slug: "credito-emprestimo-mei-2026",
    titulo: "Empréstimo para MEI 2026: Pronampe, BNDES e Crédito com Taxas Baixas",
    resumo: "Guia completo de crédito para MEI: Pronampe, BNDES Microcrédito, fintechs e como ter aprovação.",
    categoria: "credito",
  },
  {
    slug: "emprestimo-caixa-mei",
    titulo: "Empréstimo Caixa para MEI 2026: Como Pedir Crédito Passo a Passo",
    resumo: "Linhas da Caixa para MEI, requisitos, documentos e o passo a passo para pedir crédito com CNPJ MEI.",
    categoria: "credito",
  },

  {
    slug: "marketing-digital-mei",
    titulo: "Marketing Digital para MEI 2026: Como Vender pelo Instagram, WhatsApp e Google",
    resumo: "Estratégias práticas de marketing digital para MEI: perfil comercial, catálogo no WhatsApp e Google Meu Negócio.",
    categoria: "crescimento",
  },
  {
    slug: "nanoempreendedor-reforma-tributaria",
    titulo: "Nanoempreendedor e Reforma Tributária 2026: O que Muda para o MEI",
    resumo: "O MEI vai acabar? O que é o nanoempreendedor? Como o DAS muda? Tudo explicado.",
    categoria: "tributos",
  },
];

// Mapa curado: ferramenta → artigos relacionados (priorizados).
export const toolToArticles: Record<string, string[]> = {
  "calculadora-das-mei": [
    "das-boleto-mei",
    "parcelamento-dividas-mei",
    "mei-simples-nacional",
    "mei-inss-aposentadoria",
    "ferramentas-mei-kit-gratuito",
  ],
  "calculadora-multa-das": ["das-boleto-mei", "parcelamento-dividas-mei", "mei-inadimplente"],
  "limite-faturamento-mei": [
    "desenquadramento-mei-como-agir",
    "limite-faturamento-mei",
    "mei-x-me-diferencas",
    "migrar-mei-para-me",
    "ferramentas-mei-kit-gratuito",
  ],
  "simulador-irpf-mei": ["mei-imposto-de-renda", "mei-clt-carteira-assinada", "nota-fiscal-mei"],
  "simulador-desenquadramento": [
    "desenquadramento-mei-como-agir",
    "mei-x-me-diferencas",
    "migrar-mei-para-me",
    "limite-faturamento-mei",
    "ferramentas-mei-kit-gratuito",
  ],

  "calculadora-precificacao": ["mei-e-commerce", "nota-fiscal-mei", "mei-prestar-servico-pj"],
  "valor-da-hora": [
    "mei-prestar-servico-pj",
    "mei-clt-carteira-assinada",
    "mei-e-commerce",
    "ferramentas-mei-kit-gratuito",
  ],
  "margem-markup": [
    "mei-e-commerce",
    "nota-fiscal-mei",
    "calculadora-precificacao" /* fallback handled */,
    "ferramentas-mei-kit-gratuito",
  ],
  "calculadora-desconto": ["mei-e-commerce", "nota-fiscal-mei", "mei-prestar-servico-pj"],
  "calculadora-parcelamento": ["conta-pj-mei", "mei-e-commerce", "nota-fiscal-mei"],
  "calculadora-comissao": ["mei-prestar-servico-pj", "mei-e-commerce", "nota-fiscal-mei"],

  "controle-entradas-saidas": ["conta-pj-mei", "mei-imposto-de-renda", "das-boleto-mei"],
  "controle-clientes": ["nota-fiscal-mei", "mei-prestar-servico-pj", "conta-pj-mei"],
  "simulador-lucro": ["mei-imposto-de-renda", "mei-x-me-diferencas", "limite-faturamento-mei"],
  "reserva-emergencia": [
    "conta-pj-mei",
    "beneficios-previdenciarios-mei",
    "mei-inss-aposentadoria",
  ],
  "separador-despesas-mei": [
    "conta-pj-mei",
    "mei-imposto-de-renda",
    "controle-entradas-saidas" /* fallback */,
  ],

  "gerador-recibo": ["nota-fiscal-mei", "mei-prestar-servico-pj", "conta-pj-mei"],
  "gerador-contrato": ["mei-prestar-servico-pj", "nota-fiscal-mei", "mei-pode-ter-funcionario"],
  "mensagem-cobranca": ["mei-inadimplente", "mei-nome-sujo", "conta-pj-mei"],

  "validador-cnpj": [
    "como-obter-cartao-cnpj-rapido",
    "cartao-cnpj-importancia-legal",
    "vantagens-cartao-cnpj-para-empresas",
    "ferramentas-mei-kit-gratuito",
  ],
  "validador-cpf": [
    "nota-fiscal-mei",
    "como-obter-cartao-cnpj-rapido",
    "cartao-cnpj-importancia-legal",
  ],
  "calculadora-frete": ["mei-e-commerce", "nota-fiscal-mei", "atividades-permitidas-mei"],
  "verificador-cnae": ["atividades-permitidas-mei", "como-formalizar-mei", "alterar-dados-mei"],

  "calendario-mei": ["das-boleto-mei", "mei-imposto-de-renda", "portal-mei-guia-completo"],
  "tabela-das-2026": ["das-boleto-mei", "mei-simples-nacional", "reforma-tributaria-mei"],
  "checklist-abertura": [
    "como-formalizar-mei",
    "atividades-permitidas-mei",
    "portal-mei-guia-completo",
  ],
  "links-oficiais": ["portal-mei-guia-completo", "como-formalizar-mei", "certificado-digital-mei"],

  "simulador-aposentadoria-mei": [
    "mei-inss-aposentadoria",
    "beneficios-previdenciarios-mei",
    "inss-mei-2026",
  ],
  "calculadora-inss-mei": [
    "inss-mei-2026",
    "mei-inss-aposentadoria",
    "beneficios-previdenciarios-mei",
  ],
  "simulador-das-atraso": ["parcelamento-dividas-mei", "mei-inadimplente", "das-boleto-mei"],
  "gerador-orcamento-pdf": ["mei-prestar-servico-pj", "nota-fiscal-mei", "mei-e-commerce"],
  "comparador-conta-pj": ["conta-pj-mei", "comparador-conta-pj", "reserva-emergencia"],
  "simulador-emprestimo-mei": ["simulador-emprestimo-mei", "conta-pj-mei", "mei-inadimplente"],
  "simulador-maquininha": [
    "simulador-maquininha",
    "mei-e-commerce",
    "conta-pj-mei",
    "nota-fiscal-mei",
  ],
  "mei-vs-clt-2026": [
    "mei-vs-clt-2026",
    "mei-clt-carteira-assinada",
    "mei-imposto-de-renda",
    "mei-prestar-servico-pj",
  ],
  "ia-cnae-mei-2026": [
    "ia-cnae-mei-2026",
    "atividades-permitidas-mei",
    "como-formalizar-mei",
    "alterar-dados-mei",
  ],
};

// Mapa curado: ferramenta → ferramentas relacionadas (priorizadas por afinidade de intenção).
// Evita o fallback genérico por categoria e melhora topical authority.
export const toolToRelatedTools: Record<string, string[]> = {
  "calculadora-das-mei": [
    "calculadora-multa-das",
    "simulador-das-atraso",
    "tabela-das-2026",
    "calculadora-inss-mei",
  ],
  "calculadora-multa-das": [
    "calculadora-das-mei",
    "simulador-das-atraso",
    "limite-faturamento-mei",
    "tabela-das-2026",
  ],
  "limite-faturamento-mei": [
    "simulador-desenquadramento",
    "calculadora-das-mei",
    "simulador-lucro",
    "simulador-irpf-mei",
  ],
  "simulador-irpf-mei": [
    "simulador-lucro",
    "mei-vs-clt-2026",
    "limite-faturamento-mei",
    "calculadora-inss-mei",
  ],
  "simulador-desenquadramento": [
    "limite-faturamento-mei",
    "simulador-lucro",
    "calculadora-das-mei",
    "simulador-irpf-mei",
  ],

  "calculadora-precificacao": [
    "margem-markup",
    "valor-da-hora",
    "calculadora-desconto",
    "simulador-lucro",
  ],
  "valor-da-hora": [
    "calculadora-precificacao",
    "margem-markup",
    "simulador-lucro",
    "mei-vs-clt-2026",
  ],
  "margem-markup": [
    "calculadora-precificacao",
    "calculadora-desconto",
    "simulador-lucro",
    "calculadora-comissao",
  ],
  "calculadora-desconto": [
    "calculadora-precificacao",
    "margem-markup",
    "calculadora-parcelamento",
    "calculadora-comissao",
  ],
  "calculadora-parcelamento": [
    "simulador-maquininha",
    "calculadora-desconto",
    "calculadora-precificacao",
    "simulador-emprestimo-mei",
  ],
  "calculadora-comissao": [
    "calculadora-precificacao",
    "valor-da-hora",
    "simulador-lucro",
    "margem-markup",
  ],

  "controle-entradas-saidas": [
    "simulador-lucro",
    "separador-despesas-mei",
    "reserva-emergencia",
    "controle-clientes",
  ],
  "controle-clientes": [
    "mensagem-cobranca",
    "gerador-recibo",
    "gerador-contrato",
    "controle-entradas-saidas",
  ],
  "simulador-lucro": [
    "calculadora-precificacao",
    "controle-entradas-saidas",
    "reserva-emergencia",
    "limite-faturamento-mei",
  ],
  "reserva-emergencia": [
    "simulador-lucro",
    "controle-entradas-saidas",
    "comparador-conta-pj",
    "calculadora-inss-mei",
  ],
  "separador-despesas-mei": [
    "controle-entradas-saidas",
    "comparador-conta-pj",
    "reserva-emergencia",
    "simulador-lucro",
  ],

  "gerador-recibo": [
    "gerador-contrato",
    "gerador-orcamento-pdf",
    "controle-clientes",
    "mensagem-cobranca",
  ],
  "gerador-contrato": [
    "gerador-recibo",
    "gerador-orcamento-pdf",
    "controle-clientes",
    "validador-cnpj",
  ],
  "mensagem-cobranca": [
    "controle-clientes",
    "gerador-recibo",
    "calculadora-multa-das",
    "gerador-contrato",
  ],

  "validador-cnpj": ["validador-cpf", "verificador-cnae", "gerador-contrato", "gerador-recibo"],
  "validador-cpf": ["validador-cnpj", "gerador-recibo", "controle-clientes", "verificador-cnae"],
  "calculadora-frete": [
    "calculadora-precificacao",
    "margem-markup",
    "simulador-maquininha",
    "gerador-recibo",
  ],
  "verificador-cnae": [
    "ia-cnae-mei-2026",
    "checklist-abertura",
    "validador-cnpj",
    "tabela-das-2026",
  ],

  "calendario-mei": [
    "calculadora-das-mei",
    "tabela-das-2026",
    "calculadora-multa-das",
    "checklist-abertura",
  ],
  "tabela-das-2026": [
    "calculadora-das-mei",
    "calculadora-inss-mei",
    "calendario-mei",
    "simulador-desenquadramento",
  ],
  "checklist-abertura": [
    "verificador-cnae",
    "ia-cnae-mei-2026",
    "links-oficiais",
    "calculadora-das-mei",
  ],
  "links-oficiais": [
    "calendario-mei",
    "checklist-abertura",
    "verificador-cnae",
    "calculadora-das-mei",
  ],

  "simulador-aposentadoria-mei": [
    "calculadora-inss-mei",
    "reserva-emergencia",
    "calculadora-das-mei",
    "simulador-lucro",
  ],
  "calculadora-inss-mei": [
    "simulador-aposentadoria-mei",
    "calculadora-das-mei",
    "tabela-das-2026",
    "reserva-emergencia",
  ],
  "simulador-das-atraso": [
    "calculadora-multa-das",
    "tabela-das-2026",
    "calculadora-das-mei",
    "calendario-mei",
  ],
  "gerador-orcamento-pdf": [
    "gerador-recibo",
    "gerador-contrato",
    "calculadora-precificacao",
    "valor-da-hora",
  ],
  "comparador-conta-pj": [
    "separador-despesas-mei",
    "controle-entradas-saidas",
    "simulador-emprestimo-mei",
    "simulador-maquininha",
  ],
  "simulador-emprestimo-mei": [
    "calculadora-parcelamento",
    "comparador-conta-pj",
    "reserva-emergencia",
    "simulador-lucro",
  ],
  "simulador-maquininha": [
    "calculadora-parcelamento",
    "calculadora-precificacao",
    "comparador-conta-pj",
    "valor-da-hora",
  ],
  "mei-vs-clt-2026": [
    "simulador-irpf-mei",
    "calculadora-inss-mei",
    "valor-da-hora",
    "simulador-aposentadoria-mei",
  ],
  "ia-cnae-mei-2026": [
    "verificador-cnae",
    "checklist-abertura",
    "calculadora-das-mei",
    "limite-faturamento-mei",
  ],
};

export function getRelatedToolsForTool(toolSlug: string, max = 4): string[] {
  const available = new Set(tools.filter((t) => t.available).map((t) => t.slug));
  const curated = (toolToRelatedTools[toolSlug] ?? []).filter(
    (s) => s !== toolSlug && available.has(s),
  );
  const seen = new Set<string>([toolSlug, ...curated]);
  const out = [...curated];
  if (out.length < max) {
    const current = tools.find((t) => t.slug === toolSlug);
    const sameCat = current
      ? tools.filter((t) => t.available && t.category === current.category && !seen.has(t.slug))
      : [];
    for (const t of sameCat) {
      seen.add(t.slug);
      out.push(t.slug);
      if (out.length >= max) break;
    }
  }
  if (out.length < max) {
    for (const t of tools) {
      if (!t.available || seen.has(t.slug)) continue;
      seen.add(t.slug);
      out.push(t.slug);
      if (out.length >= max) break;
    }
  }
  return out.slice(0, max);
}

// Mapa curado: artigo → ferramentas relacionadas (priorizadas).
export const articleToTools: Record<string, string[]> = {
  "o-que-e-mei": ["calculadora-das-mei", "limite-faturamento-mei", "checklist-abertura"],
  "como-formalizar-mei": ["checklist-abertura", "verificador-cnae", "links-oficiais"],
  "portal-mei-guia-completo": ["links-oficiais", "calendario-mei", "calculadora-das-mei"],
  "atividades-permitidas-mei": ["verificador-cnae", "checklist-abertura", "calculadora-das-mei"],
  "alvara-funcionamento-mei": ["links-oficiais", "checklist-abertura", "verificador-cnae"],
  "certificado-digital-mei": ["links-oficiais", "validador-cnpj", "calculadora-das-mei"],
  "alterar-dados-mei": ["verificador-cnae", "links-oficiais", "validador-cnpj"],

  "das-boleto-mei": ["calculadora-das-mei", "calculadora-multa-das", "tabela-das-2026"],
  "como-calcular-das-mei-2026": ["calculadora-das-mei", "tabela-das-2026", "calculadora-multa-das"],
  "limite-faturamento-mei": [
    "limite-faturamento-mei",
    "simulador-desenquadramento",
    "simulador-lucro",
  ],
  "mei-imposto-de-renda": ["simulador-irpf-mei", "simulador-lucro", "controle-entradas-saidas"],
  "mei-simples-nacional": ["calculadora-das-mei", "tabela-das-2026", "simulador-desenquadramento"],
  "reforma-tributaria-mei": [
    "calculadora-das-mei",
    "tabela-das-2026",
    "simulador-desenquadramento",
  ],
  "nota-fiscal-mei": ["gerador-recibo", "validador-cnpj", "validador-cpf"],
  "microempreendedor-individual-nota-fiscal-eletronica": [
    "gerador-recibo",
    "validador-cnpj",
    "validador-cpf",
  ],
  "inss-mei-2026": ["calculadora-das-mei", "tabela-das-2026", "reserva-emergencia"],
  "obrigacoes-mensais-mei": ["calendario-mei", "calculadora-das-mei", "checklist-abertura"],

  "parcelamento-dividas-mei": ["calculadora-multa-das", "calculadora-das-mei", "mensagem-cobranca"],
  "mei-inadimplente": ["calculadora-multa-das", "mensagem-cobranca", "calculadora-das-mei"],
  "mei-nome-sujo": ["mensagem-cobranca", "calculadora-multa-das", "reserva-emergencia"],
  "como-cancelar-mei-dar-baixa": ["links-oficiais", "checklist-abertura", "calculadora-das-mei"],

  "mei-pode-ter-funcionario": ["gerador-contrato", "simulador-lucro", "controle-entradas-saidas"],
  "mei-pode-ter-socio": ["simulador-desenquadramento", "verificador-cnae", "calculadora-das-mei"],
  "mei-clt-carteira-assinada": ["simulador-irpf-mei", "calculadora-das-mei", "valor-da-hora"],

  "mei-inss-aposentadoria": ["calculadora-das-mei", "reserva-emergencia", "tabela-das-2026"],
  "beneficios-previdenciarios-mei": [
    "calculadora-das-mei",
    "reserva-emergencia",
    "tabela-das-2026",
  ],

  "mei-x-me-diferencas": [
    "simulador-desenquadramento",
    "limite-faturamento-mei",
    "simulador-lucro",
  ],
  "migrar-mei-para-me": [
    "simulador-desenquadramento",
    "limite-faturamento-mei",
    "calculadora-das-mei",
  ],
  "desenquadramento-mei-como-agir": [
    "simulador-desenquadramento",
    "limite-faturamento-mei",
    "calculadora-multa-das",
  ],
  "mei-e-commerce": ["calculadora-precificacao", "calculadora-frete", "margem-markup"],
  "mei-feminino": ["calculadora-precificacao", "valor-da-hora", "controle-clientes"],
  "mei-prestar-servico-pj": ["gerador-contrato", "valor-da-hora", "gerador-recibo"],
  "conta-pj-mei": ["comparador-conta-pj", "separador-despesas-mei", "controle-entradas-saidas"],
  "comparador-conta-pj": ["comparador-conta-pj", "separador-despesas-mei", "reserva-emergencia"],
  "simulador-emprestimo-mei": [
    "simulador-emprestimo-mei",
    "reserva-emergencia",
    "calculadora-parcelamento",
  ],
  "simulador-maquininha": [
    "simulador-maquininha",
    "calculadora-parcelamento",
    "calculadora-precificacao",
    "comparador-conta-pj",
  ],
  "mei-vs-clt-2026": [
    "mei-vs-clt-2026",
    "simulador-irpf-mei",
    "calculadora-inss-mei",
    "calculadora-das-mei",
  ],
  "ia-cnae-mei-2026": [
    "ia-cnae-mei-2026",
    "verificador-cnae",
    "checklist-abertura",
    "calculadora-das-mei",
  ],
  "entregador-mercado-livre-mei": [
    "ia-cnae-mei-2026",
    "checklist-abertura",
    "calculadora-das-mei",
    "verificador-cnae",
  ],

  "como-obter-cartao-cnpj-rapido": ["validador-cnpj", "links-oficiais", "checklist-abertura"],
  "vantagens-cartao-cnpj-para-empresas": [
    "validador-cnpj",
    "controle-clientes",
    "gerador-contrato",
  ],
  "passo-a-passo-solicitar-cartao-cnpj": ["validador-cnpj", "links-oficiais", "checklist-abertura"],
  "cartao-cnpj-documentacao-necessaria-dicas": [
    "validador-cnpj",
    "checklist-abertura",
    "links-oficiais",
  ],
  "cartao-cnpj-importancia-legal": ["validador-cnpj", "gerador-contrato", "controle-clientes"],
  "ferramentas-mei-kit-gratuito": [
    "calculadora-das-mei",
    "calculadora-multa-das",
    "simulador-irpf-mei",
    "limite-faturamento-mei",
    "validador-cnpj",
    "simulador-desenquadramento",
    "valor-da-hora",
    "margem-markup",
    "simulador-das-atraso",
    "ia-cnae-mei-2026",
  ],
};

const articleMap = new Map(articlesMeta.map((a) => [a.slug, a]));

function pickArticles(slugs: string[], excludeSlug: string, max: number): ArticleMeta[] {
  const seen = new Set<string>([excludeSlug]);
  const out: ArticleMeta[] = [];
  for (const s of slugs) {
    if (seen.has(s)) continue;
    const a = articleMap.get(s);
    if (!a) continue;
    seen.add(s);
    out.push(a);
    if (out.length >= max) break;
  }
  // Preenche com qualquer artigo ainda não usado
  if (out.length < max) {
    for (const a of articlesMeta) {
      if (seen.has(a.slug)) continue;
      seen.add(a.slug);
      out.push(a);
      if (out.length >= max) break;
    }
  }
  return out;
}

export function getRelatedArticlesForTool(toolSlug: string, max = 3): ArticleMeta[] {
  return pickArticles(toolToArticles[toolSlug] ?? [], "", max);
}

export function getRelatedArticlesForArticle(articleSlug: string, max = 3): ArticleMeta[] {
  const current = articleMap.get(articleSlug);
  const sameCat = current
    ? articlesMeta
        .filter((a) => a.categoria === current.categoria && a.slug !== articleSlug)
        .map((a) => a.slug)
    : [];
  return pickArticles(sameCat, articleSlug, max);
}

const toolSlugs = new Set(tools.filter((t) => t.available).map((t) => t.slug));

export function getRelatedToolsForArticle(articleSlug: string, max = 3): string[] {
  const curated = (articleToTools[articleSlug] ?? []).filter((s) => toolSlugs.has(s));
  const seen = new Set<string>(curated);
  const out = [...curated];
  if (out.length < max) {
    for (const t of tools) {
      if (!t.available || seen.has(t.slug)) continue;
      seen.add(t.slug);
      out.push(t.slug);
      if (out.length >= max) break;
    }
  }
  return out.slice(0, max);
}
